<script setup lang="ts">
import type { ApiLogisticsTaskGetById, ApiPublicTransportationCompanyDriveGetLogisticsTaskByCuid } from '~/types'

const props = defineProps<{ logisticsTask: ApiLogisticsTaskGetById | ApiPublicTransportationCompanyDriveGetLogisticsTaskByCuid, isPublicPage?: boolean }>()

const isPublicPage = computed(() => props.isPublicPage ?? false)

const logisticsTaskId = computed(() => {
  if (isPublicPage.value) {
    return props.logisticsTask.cuid
  }
  return props.logisticsTask.id
})

const { openDriverLoadingChecklistPopup } = useGlobalOpeners()
const outboundTour = props.logisticsTask.type === 'outbound'
const isPlanned = Boolean(props.logisticsTask.deliveryAt && (props.logisticsTask.assignedDeliveryVehicleId || props.logisticsTask.doesCustomerDoTask || props.logisticsTask.doesFitterDoTask || props.logisticsTask.doesTransportationCompanyDoTask))

// TODO(dispo refactoring): Do we want to enfore something different to see if something was issued?
const isIssued = Boolean(props.logisticsTask.positionsToShip.some(p => p.issuedAt))

const isEditingDisabled = computed(() => props.logisticsTask.status !== 'loaded')

const publicLoadingChecklistPayload = ref<string | null>(null)

function openLoadingChecklist() {
  if (isPublicPage.value) {
    publicLoadingChecklistPayload.value = logisticsTaskId.value
    return
  }
  openDriverLoadingChecklistPopup.open({ id: logisticsTaskId.value })
}
</script>

<template>
  <TheDataCard>
    <template #header>
      <div class="CardHeader">
        <h2>{{ $t('logisticsTask.loadingChecklist.title') }}</h2>
        <n-button
          v-if="outboundTour && !isEditingDisabled && !isPublicPage"
          @click="openLoadingChecklist"
        >
          <template #icon>
            <Icon name="material-symbols:edit-outline-rounded" />
          </template>
          {{ $t('button.update') }}
        </n-button>
      </div>
    </template>

    <template v-if="outboundTour && isPlanned && isIssued">
      <div v-if="'created' === logisticsTask.status" class="flex justify-between">
        <span>{{ $t('common.empty') }}</span>
        <n-button v-if="!isPublicPage" @click="openLoadingChecklist">
          {{ $t('logisticsTask.checklist.fillOut') }}
        </n-button>
      </div>
      <DriverLoadingChecklistForm v-else :logistics-task="logisticsTask" :view-only="true" />
    </template>
    <div v-else class="text-center mt-5">
      {{ $t('logisticsTask.loadingChecklist.notApplicable') }}
    </div>
  </TheDataCard>

  <DriverPublicTransportationCompanyLoadingChecklistContainer v-if="publicLoadingChecklistPayload" :logistics-task-cuid="publicLoadingChecklistPayload" @close="publicLoadingChecklistPayload = null" />
</template>

<style scoped>
.CardHeader {
  @apply  w-full flex justify-between mb-5
}
.CardHeader h2 {
  @apply text-lg font-semibold
}
</style>
